import { Button, HStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

type ScannerNameControlProps = {
  editMode: boolean;
  onEditModeChange: () => void;
  handleSave: () => void;
  handleCancel: () => void;
  saveButtonDisabled: boolean;
};

export const ScannerNameControl: React.FC<ScannerNameControlProps> = ({
  editMode,
  onEditModeChange,
  handleSave,
  handleCancel,
  saveButtonDisabled,
}) => {
  const { t } = useTranslation('telemetryScannerConfig', {
    keyPrefix: 'scannerInformation',
  });

  return editMode === true ? (
    <HStack>
      <Button variant="tertiary" onClick={handleCancel}>
        {t('cancelChanges')}
      </Button>
      <Button
        variant="primary"
        onClick={handleSave}
        isDisabled={saveButtonDisabled}
      >
        {t('saveChanges')}
      </Button>
    </HStack>
  ) : (
    <Button variant="tertiary" onClick={onEditModeChange}>
      {t('editInformation')}
    </Button>
  );
};
